




























































































































































import { Component, Vue } from "vue-property-decorator";
import { API } from "@/shared/api";
import { ssmHttpService } from "@/shared/services/http-service";
import { MessageService } from "@/shared/services/message-service";

@Component({ name: "CitasEliminarManager" })
export default class CitasEliminarManager extends Vue {
  public cargando = false;
  public eliminando = false;
  public busqueda = "";
  public filtroCentro: number | null = null;
  public filtroEstado: string | null = null;
  public fechaDesde: string | null = null;
  public fechaHasta: string | null = null;
  public seleccionadas: any[] = [];
  public todasLasFilas: any[] = [];
  public catalogos: any = { centros: [], estados: [] };

  public headers = [
    { text: "ID", value: "id", width: 70, sortable: true },
    { text: "Paciente", value: "paciente_nombre", sortable: true },
    { text: "Centro", value: "centro_nombre", sortable: true },
    { text: "Servicio", value: "servicio_nombre", sortable: true },
    { text: "Estado", value: "estado_codigo", sortable: true },
    { text: "Fecha solicitada", value: "fecha_hora_inicio_solicitada", sortable: true },
    { text: "Creada", value: "created_at", sortable: true },
  ];

  get centrosSelect() {
    return (this.catalogos.centros || []).map((c: any) => ({
      text: c.nombre,
      value: c.id,
    }));
  }

  get estadosSelect() {
    return (this.catalogos.estados || []).map((e: any) => ({
      text: e.nombre,
      value: e.codigo,
    }));
  }

  get filasFiltradas(): any[] {
    let rows = this.todasLasFilas;
    if (this.filtroCentro) {
      rows = rows.filter((r) => r.id_centro === this.filtroCentro);
    }
    if (this.filtroEstado) {
      rows = rows.filter((r) => r.estado_codigo === this.filtroEstado);
    }
    if (this.fechaDesde) {
      const desde = new Date(this.fechaDesde);
      rows = rows.filter((r) => r.fecha_hora_inicio_solicitada && new Date(r.fecha_hora_inicio_solicitada) >= desde);
    }
    if (this.fechaHasta) {
      const hasta = new Date(this.fechaHasta);
      hasta.setHours(23, 59, 59);
      rows = rows.filter((r) => r.fecha_hora_inicio_solicitada && new Date(r.fecha_hora_inicio_solicitada) <= hasta);
    }
    return rows;
  }

  async mounted() {
    await Promise.all([this.cargarCatalogos(), this.cargarDatos()]);
  }

  public async cargarCatalogos() {
    try {
      const res = await ssmHttpService.get(`${API.solicitudesWorkflow}/admin/catalogos`, null, false);
      const data = res && res.data ? res.data : res;
      this.catalogos = data || { centros: [], estados: [] };
    } catch (e) {
      // catálogos no críticos
    }
  }

  public async cargarDatos() {
    this.cargando = true;
    try {
      const res = await ssmHttpService.get(`${API.solicitudesWorkflow}/admin/tablero`, null, false);
      const rows = (res && res.data ? res.data.rows : res && res.rows ? res.rows : []) || [];
      this.todasLasFilas = rows;
      this.seleccionadas = [];
    } catch (e) {
      MessageService.alert("Error", "No se pudieron cargar las citas.", MessageService.TypeError);
    } finally {
      this.cargando = false;
    }
  }

  public confirmarEliminarSeleccionadas() {
    const n = this.seleccionadas.length;
    MessageService.confirm(
      `¿Eliminar ${n} cita(s) de forma permanente y silenciosa? Esta acción no se puede deshacer.`,
      "Confirmar eliminación",
      async (res: boolean) => {
        if (!res) return;
        await this.ejecutarBulkDelete(this.seleccionadas.map((x: any) => x.id));
      }
    );
  }

  public confirmarEliminarTodo() {
    MessageService.confirm(
      "¿Estás seguro? Esto eliminará ABSOLUTAMENTE TODAS las citas de la base de datos.",
      "Borrar todo — Primer aviso",
      (res1: boolean) => {
        if (!res1) return;
        MessageService.confirm(
          "Esta acción es IRREVERSIBLE. No se enviará ninguna notificación. ¿Continuar?",
          "Borrar todo — Confirmación final",
          async (res2: boolean) => {
            if (!res2) return;
            await this.ejecutarEliminarTodo();
          }
        );
      }
    );
  }

  private async ejecutarBulkDelete(ids: number[]) {
    this.eliminando = true;
    MessageService.showLoading();
    try {
      const r = await ssmHttpService.post(API.solicitudesWorkflowBulkDelete, { ids }, false, false, false);
      const eliminadas = r && r.eliminadas !== undefined ? r.eliminadas : ids.length;
      MessageService.toast(`${eliminadas} cita(s) eliminadas correctamente.`);
      this.seleccionadas = [];
      await this.cargarDatos();
    } catch (e) {
      MessageService.alert("Error", "No se pudieron eliminar las citas.", MessageService.TypeError);
    } finally {
      this.eliminando = false;
      MessageService.hideLoading();
    }
  }

  private async ejecutarEliminarTodo() {
    this.eliminando = true;
    MessageService.showLoading();
    try {
      const r = await ssmHttpService.post(API.solicitudesWorkflowEliminarTodo, {}, false, false, false);
      const eliminadas = r && r.eliminadas !== undefined ? r.eliminadas : 0;
      MessageService.toast(`${eliminadas} cita(s) eliminadas. Base de datos limpia.`);
      await this.cargarDatos();
    } catch (e) {
      MessageService.alert("Error", "No se pudo realizar la operación.", MessageService.TypeError);
    } finally {
      this.eliminando = false;
      MessageService.hideLoading();
    }
  }

  public limpiarFiltros() {
    this.busqueda = "";
    this.filtroCentro = null;
    this.filtroEstado = null;
    this.fechaDesde = null;
    this.fechaHasta = null;
  }

  public formatFecha(val: string): string {
    if (!val) return "-";
    try {
      const d = new Date(val);
      return d.toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
    } catch (e) {
      return val;
    }
  }

  public colorEstado(codigo: string): string {
    const map: Record<string, string> = {
      pendiente: "orange",
      en_revision: "blue",
      confirmada: "teal",
      enviada_gesden: "cyan",
      insertada_gesden: "green",
      conflicto: "red",
      fallida_gesden: "deep-orange",
      cancelada: "grey",
      rechazada: "red darken-3",
      expirada: "blue-grey",
    };
    return map[codigo] || "grey";
  }
}
